import { render, staticRenderFns } from "./FactorListActions.vue?vue&type=template&id=89330888"
import script from "./FactorListActions.vue?vue&type=script&lang=js"
export * from "./FactorListActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports